import React, { useEffect, useRef, useState } from 'react';
import './style.scoped.scss';
import { Button, Modal } from 'react-bootstrap';
import { IoMdClose } from 'react-icons/io';
import { emailRegex } from '../../assets/constants/strings';
import { connect } from 'react-redux';

const mapStateToProps = (state) => ({
  user: state.user.user,
});

// const mapDispatchToProps = { sendQuote };

const connector = connect(mapStateToProps, {});

const ContactUsModal = ({ user, show, handleClose }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [organisation, setOrganisation] = useState('');
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1000);

  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth < 1000;
    setIsSmallScreen(screenRef.current);
  };

  useEffect(() => {
    if (user) {
      setFirstName(user.firstName ? user.firstName : '');
      setLastName(user.lastName ? user.lastName : '');
      setEmail(user.email ? user.email : '');
      setOrganisation(user.organisation ? user.organisation : '');
    }
  }, [user]);

  return (
    <Modal show={show} onHide={handleClose} centered size='lg'>
      <Modal.Header>
        <Modal.Title>Contact Us</Modal.Title>
        <IoMdClose onClick={handleClose} style={{ cursor: 'pointer' }} />
      </Modal.Header>
      <Modal.Body>
        <form
          // onSubmit={handleConfirm}
          className='mt-3 text-center'
          autoComplete='off'
        >
          <div className={isSmallScreen ? 'inputsColumn' : 'inputsRow'}>
            <div className='form-group mb-3'>
              <input
                className='form-control'
                placeholder='First Name'
                id='FirstName'
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
                maxLength={35}
                required
              />
            </div>
            <div className='form-group mb-3 mr-0'>
              <input
                className='form-control'
                placeholder='Last Name'
                id='LastName'
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
                maxLength={35}
                required
              />
            </div>
          </div>
          <div className={isSmallScreen ? 'inputsColumn' : 'inputsRow'}>
            <div className='form-group mb-3'>
              <input
                className={`form-control${
                  email.length === 0
                    ? ''
                    : emailRegex(email)
                    ? ' is-valid'
                    : ' is-invalid'
                }`}
                placeholder='Email'
                type='email'
                id='Email'
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                maxLength={320}
                required
              />
            </div>
            <div className='form-group mb-3 mr-0'>
              <input
                className='form-control'
                placeholder='Company Name'
                id='CompanyName'
                type='text'
                onChange={(e) => setOrganisation(e.target.value)}
                value={organisation}
                required={true}
              />
            </div>
          </div>
          <textarea
            placeholder='Type your message here'
            className='w-100'
            rows={5}
          />
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button className='updateSubsBtn w-100' onClick={handleClose}>
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default connector(ContactUsModal);
